<template>
  <div class="dropdown-group">
    <label class="question-label">{{ label }}</label>
    <div
      class="dropdown-wrapper"
      @blur="isOpen = false"
      v-click-outside="() => (isOpen = false)"
    >
      <button
        :class="{ dropdown: true, open: isOpen }"
        @click.prevent="isOpen = !isOpen"
      >
        {{ selected !== null ? options[selected].text : caption }}
        <i :class="{ arrow: true, down: !isOpen, up: isOpen }"></i>
      </button>
      <div :class="{ options: true, selectShow: isOpen }" v-show="isOpen">
        <div
          class="option"
          v-for="(option, i) of options"
          :key="i"
          @click="
            isOpen = false;
            selected = i;
            $emit('changed', option.id, option.nextGroupID);
          "
        >
          {{ option.text }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { clickOutside } from "../directives/click-outside";

export default {
  name: "Dropdown",
  directives: {
    clickOutside
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    caption: {
      type: String,
      required: true
    },
    label: {
      type: String
    }
  },
  data: function() {
    return {
      isOpen: false,
      selected: null
    };
  }
};
</script>